import styled from 'styled-components';

export const CategoryFilterItemWrapper = styled.div`
    display: flex;
    margin-top: 10px;
    cursor: pointer;

    > div:last-child {
        padding-left: 8px;
    }
`;